export const LOCALSTORAGEKEY = process.env.LOCALSTORAGEKEY;

export const defaultState = {
	user: {
		location: {},
		account: {},
		currentPaymentMethod: {},
		registerError: null,
		loginError: null
	},
	menuList: {},
	menus: {},
	venue: {},
	timeslots: [],
	basket: {
		lines: [],
		status: {},
		timeslot: '',
		invalidItems: []
	},
	order: {},
	menuId: null,
	breakpoint: 'initial',
	waitTime: 26,
	iframe: false,
	locations: [],
	brand: null,
	offline: false,
	lastRoute: null,
	locationsLoaded: false,
	uiCopy: {}
};

function getLocalData(name, def) {
	let d = window.localStorage.getItem(`${LOCALSTORAGEKEY}_${name.toUpperCase()}`);
	if (!d) return def;
	return JSON.parse(d);
}

export const loadState = () => {
	let state = {};
	for (let prop in defaultState) {
		if (defaultState.hasOwnProperty(prop)) {
			state[prop] = getLocalData(prop, defaultState[prop]);
		}
	}
	return state;
};

export const saveState = store => {
	store.subscribe((mutation, data) => {
		for (let prop in data) {
			if (data.hasOwnProperty(prop)) {
				window.localStorage.setItem(`${LOCALSTORAGEKEY}_${prop.toUpperCase()}`, JSON.stringify(data[prop]));
			}
		}
	});
};



// WEBPACK FOOTER //
// ./src/vue/store/localstorage-manager.js